<template>
  <p class="OfferCardLeadingTitle">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'OfferCardLeadingTitle',
}
</script>

<style lang="scss">
.OfferCardLeadingTitle,
.OfferCardLeadingTitle * {
  box-sizing: border-box;
}
.OfferCardLeadingTitle {
  @include subtitle-2;
  color: $color-black-high;
  position: relative;
  align-self: stretch;
  margin: 0;
}
</style>
